<template>
  <div
    class="flex justify-between py-16 px-16 items-end"
    :class="{
      'bg-transparent': index % 2 !== 0,
      'bg-secondary-default': index % 2 === 0,
      'text-black': (index % 2 === 0 && backgroundDarkText) || (index % 2 !== 0 && darkText),
      'text-white': (index % 2 === 0 && !backgroundDarkText) || (index % 2 !== 0 && !darkText),
    }"
  >
    <div class="flex">
      <div class="w-56 flex items-center">
        <i
          class="sh-icon text-[32px]"
          :class="{
            [`sh-icon-${incidentItem.incident_template_icon}`]: incidentItem.incident_template_icon
          }"
        />
      </div>
      <div>
        <div class="base-xs-medium">
          {{ incidentItem.name }}
        </div>
        <div
          class="base-xs"
          :class="{
            'text-black': index % 2 === 0 && backgroundDarkText && !isStandardTheme,
            'text-white': index % 2 === 0 && !backgroundDarkText && !isStandardTheme,
            'text-small': isStandardTheme,
          }"
        >
          {{ `${incidentItem.address}${incidentItem.location_city ? ', ' + incidentItem.location_city : ''}` }}
        </div>
      </div>
    </div>
    <div class="flex flex-col items-end">
      <div v-if="incidentItem.police_email_id" class="base-xs flex items-center">
        Skickad till polis
        <ion-icon
          aria-hidden="true"
          class="text-orange rotate-45 ml-2 mb-2 base"
          :icon="arrowUp"
        />
      </div>
      <div
        class="base-xs"
        :class="{
          'text-black': index % 2 === 0 && backgroundDarkText && !isStandardTheme,
          'text-white': index % 2 === 0 && !backgroundDarkText && !isStandardTheme,
          'text-small': isStandardTheme,
        }"
      >
        {{ getLocaleDate(incidentItem.created_at) }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {  IonIcon } from '@ionic/vue';
import { getLocaleDate } from '@/util/parseDates';
import { arrowUp } from 'ionicons/icons';
import { Incident } from '@/constants/types/api';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/user';

defineProps<{
  incidentItem: Incident;
  index: number;
}>();

const userStore = useUserStore();
const { backgroundDarkText, darkText, isStandardTheme } = storeToRefs(userStore);

</script>
